/*
* @desc 将第三方插件注册到Vue原型中，组件内可直接使用 this.xxx来调用组件
* @update --
*/

import * as filters from '@utils/filters'
import * as common from '@utils/common'
// import getLodop from './lodopFuncs'
import newMessage from './newMessage'

import dayjs from 'dayjs'
import Api from '@api'
import { bus, deconstrucForm, timeRangeHandler, combineForm, resolveForm, taday } from '../utils/common'
export default {
  customPlugin: {
    install (Vue, options) {
      // 将第三方插件注册到Vue原型中，组件内可直接使用 this.xxx来调用组件
      Object.assign(Vue.prototype, {
        $componentName () {
          console.log(Vue.name)
        },
        $ELEMENT: { size: 'small' },
        $lang: filters.lang,
        $t: filters.lang,
        $bus: bus,
        $deconstrucForm: deconstrucForm,
        $resolveForm: resolveForm,
        $timerangeHandle: timeRangeHandler,
        $combineForm: combineForm,
        $api: Api.API.public,
        $API_INTER: Api.API.international,
        $API_F: Api.API.some,
        $common: common,
        $dayjs: dayjs,
        // $getLodop: getLodop,
        $newMessage: newMessage,
        $msg: newMessage,
        $taday: taday,
      })
    },
  },
  // Avue
}
